<!--
 * @Description: 
 * @FilePath: \京东互动积分B端\src\views\integralCenter\NewHome\page_home.vue
-->
<template>
  <div>
    <div class='tip'>温馨提示：若您使用京获客设置活动，并将活动链接投放到APP首焦、站外投放等大流量的资源位入口，请联系我们客服进行报备，以便我们更好的配合活动节奏，保障活动稳定~</div>
    <div class="glurTop">
      <img
        src="@/assets/thdImg/home/bannerbg.png"
        class="pointer"
        style="width: 100%;"
        alt=""
        srcset=""
        @click="handleCreate({ path: 'brandCustom' })"
      />
      <!-- <div class="glurTop_btn pointer" @click="on_banner"></div> -->
    </div>
    <div class="integral_Home_content">
      <div class="glurLeft">
        <!-- 左边模块 -->
        <div class="left">
          <div class="hot hotImg">
            热门推荐
          </div>
          <!-- 公告 -->
          <div class="modular_Adsense">
            <div class="modular_content" v-for="item in popularList" :key="item.id">
              <div class="content_top">
                <div class="content_img">
                  <img style="width:100%;height:320px" :src="item.img" alt="" />
                </div>
                <div class="content_bgimg">
                  <div class="adsense_wz">
                    <div class="adsense_cont">
                      {{ item.des }}
                    </div>
                    <div class="adsense_btn pointer" @click="handleCreate(item)">
                      立即创建
                    </div>
                  </div>
                </div>
              </div>
              <div class="content_bottom">
                {{ item.name }}
              </div>
            </div>
          </div>

          <div class="hot mapImg">
            能力地图
          </div>
          <!-- 能力地图 -->
          <div class="modular_QuickEntrance">
            <div class="ability_map" v-for="item in mapList" :key="item.id">
              <div class="ability_top">
                <img :src="item.logo" style="margin-right: 3px;" alt="" />
                {{ item.name }}
              </div>
              <div class="ability_bottom">
                <div class="action" v-for="val in item.children" :key="val.id">
                  <div class="action_img">
                    <img :src="val.icon" alt="" />
                  </div>
                  <div class="action_js">
                    <div class="action_js_wz" style="font-size: 15px;">
                      {{ val.name }}
                      <span v-if="val.des" style="font-size: 12px;">{{ val.des }}</span>
                    </div>
                    <div class="action_js_btn pointer" @click="handleCreate(val)">
                      立即创建
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="glurRight">
        <!-- 右边模块 -->
        <div class="right">
          <div class="shop_Details" style="height: 120px;">
            <div class="news">
              <div class="news_content mapImg">活动管理</div>
            </div>
            <div class="act_details">
              <div class="act_details_pro pointer" @click="handleActCount(2)">
                <img src="@/assets/thdImg/home/wks.svg" alt="" />
                <div class="act_details_content">
                  <span>{{ actCount.notStart || 0 }}</span>
                  <div>未开始</div>
                </div>
              </div>
              <div class="act_details_pro pointer" style="margin-left: 16px;" @click="handleActCount(1)">
                <img src="@/assets/thdImg/home/jxz.svg" alt="" />
                <div class="act_details_content">
                  <span>{{ actCount.running || 0 }}</span>
                  <div>进行中</div>
                </div>
              </div>
            </div>

            <div class="shopDetails_ExpirationTime" v-if="TimeRenew && shopDetails.day < 10">
              <img src="@/assets/images/integralCenter/NewHome/Time.svg" alt="" />
              <div class="close">
                <img src="@/assets/images/integralCenter/NewHome/close.svg" alt="" @click="close_TimeRenew" />
              </div>
              <div class="conte">
                <span class="conte_1">
                  <mark>{{ shopDetails.day }}</mark
                  >天
                </span>
                <span>距离软件到期</span>
              </div>
              <div class="Exp-btn">
                <div class="btn" @click="on_renew">立即续订></div>
              </div>
            </div>
          </div>

          <!-- 店铺信息 -->
          <div class="shop_Details">
            <!-- 轮播图 -->
            <div class="poster">
              <el-carousel>
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                  <img :src="item.imgUrl" @click="handleBanner(item)" />
                </el-carousel-item>
              </el-carousel>
            </div>

            <div class="news">
              <div class="news_content mapImg">公告</div>
              <!-- <span class="news_more pointer" @click="navTo({ url: 'https://www.yuque.com/yunduanxincrm/kw5ag6' })">更多>></span> -->
            </div>
            <div class="information_hd">
              <div class="information_wz" v-for="item in actNotList" :key="item.id">
                <span class="information_wz_but" :style="{ 'border-color': item.colour, color: item.colour }">
                  {{ item.type === 0 ? "通知" : item.type === 1 ? "活动" : item.type === 2 ? "新功能" : "下线" }}
                </span>
                <span class="information_wz_name pointer" @click="navTo(item.url, item)">{{ item.title }}</span>
                <span class="information_wz_time">{{ item.createDate.substring(0, 10) }}</span>
              </div>
            </div>
          </div>

          <div class="customer_service">
            <!-- 联系客服 -->
            <div class="contact">
              <div class="contact_title mapImg">联系客服</div>
              <div class="contact_wz">热线电话：020-28970151</div>
              <div class="contact_wz">周末客服：18925068928</div>
              <div class="contact_wz">咚咚咨询：dd_1jm8pmp5oonqa</div>
              <!-- <div class="contact_wz qq_service">
                旺旺咨询：
                <span @click="on_QQ(1)" class="service1 pointer">客服1</span>
                <span @click="on_QQ(2)" class="service1 pointer">客户2</span>
              </div> -->
              <div class="contact_wz">微信咨询：yunduanxin-yunqi</div>
              <div class="contact_wz contact_code" style="margin-left: 1px;">
                扫码添加客服：
                <img src="@/assets/images/integralCenter/NewHome/code-three.png" alt="" />
              </div>
              <!-- <div class="contact_code">
                <img src="@/assets/images/integralCenter/NewHome/code-three.png" alt="" />
              </div> -->
              <div class="contact_manual">
                <div class="contact_manual_btn pointer" @click="handleWord('1')">使用手册</div>
                <div class="contact_manual_btn pointer" @click="handleWord('2')">智能问答</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 系统提示 手机-->
      <system-dialog v-if="userphoneVisible" @close="closeSystemTip"></system-dialog>
      <!-- 公告 -->
      <!-- <notiece-dialog v-if="visibleXitou" @close="handleClose"></notiece-dialog> -->
      <!-- 公告内容弹窗 -->
      <el-dialog title="系统公告" width="800px" :close-on-click-modal="false" :visible.sync="noticeDialogVisible">
        <div style="height: 550px;overflow-y: auto;padding-bottom: 20px;" v-html="linkContent"></div>
      </el-dialog>
      <!-- 弹窗 -->
      <el-dialog
        title="系统公告"
        :visible.sync="isPopVisiv"
        width="800px"
        :before-close="beforeClose"
        :class="{ dialong_transition: popItem.type == 0 }"
        :close-on-click-modal="false"
      >
        <div style="display: flex;justify-content: center;" v-if="popItem.type == 0">
          <div style="position: relative;">
            <img @click="handleUrl" class="pointer" :src="popItem.pcPic" alt style="max-width:100%;margin: 0 auto;margin-top: 38px;" />
            <img class="pointer" style="position: absolute;" @click="beforeClose" src="@/assets/images/btn_关闭.png" alt="" width="29" height="29" />
          </div>
        </div>
        <template v-else>
          <div style="height: 500px;overflow-y: auto;padding-bottom: 20px;" v-html="popItem.richText"></div>
        </template>
      </el-dialog>
      <div id="whiteBar"></div>
    </div>

    <!-- NPS组件 -->
    <shop-common-components type="NPS" :custom-params.prop="customParams"></shop-common-components> 
  </div>
</template>

<script>
import { get as getPoint } from "../../../api/axios2";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import systemDialog from "@/components/system-dialog";
import { querySellerSetting } from "@/api/userInform"; //判断是否有绑定手机号
import { getHomeGetCarousel, activityCount, activitysysNotice, validPopups, displayRecord } from "@/api/homePage";
import { getSellerInfo,newAndOldShopIsPopUp,getMAToken,getOnceToken } from "@/api/sellerController";
import notieceDialog from "./notice";

export default {
  name: "pageHome",

  data() {
    return {
      appKey: "22AF00009B3D46B8DECBC457090B3560",
      componentId: "B8CABEC9CBBD5815C4C7BB89D7D45461",
      access: false,
      frontComponentUrl:"",
      reqId: "",
      isPopVisiv: false,
      popItem: {},
      popList: [],
      popIndex: 0,
      // 公共
      noticeDialogVisible: false,
      linkContent: "",
      visibleXitou: false,
      isShowNewTip: false,
      venderId: null,
      quickEntranceList: [
        { path: "integralTask", id: 1, title: "日历签到", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_rlqd.svg") },
        { path: "integralTask", id: 5, title: "邀请开卡", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_yqkk.svg") },
        { path: "integralTask", id: 7, title: "完善信息有礼", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_wsyl.svg") },
        { path: "integralTask", id: 3, title: "每日抢好礼", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_mr.svg") },
        { path: "integralTask", id: 4, title: "关注店铺有礼", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_gzdy.svg") },
        { path: "integralEden", id: 6, title: "幸运抽奖", icon: require("@/assets/images/integralCenter/NewHome/QuickEntrance_dzp.svg") },
      ],
      recommendList: [
        {
          path: "integralTask",
          id: 13,
          title: "开卡礼包",
          icon: require("@/assets/images/integralCenter/NewHome/Recommend_kklb.png"),
          content: "会员礼包是商家设置的进店礼包，买家进店直接弹出，可针对非会员和会员人群基础上选择目标人群。",
        },
        {
          path: "integralTask",
          id: 14,
          title: "店铺礼包",
          icon: require("@/assets/images/integralCenter/NewHome/Recommend_dplb.png"),
          content: "是商家自定义礼包样式，可配置商品链接，在投放人群中引导加购商品。",
        },
        {
          path: "integralTask",
          id: 5,
          title: "邀请开卡",
          icon: require("@/assets/images/integralCenter/NewHome/Recommend_yqkk.png"),
          content: "引导用户邀请好友开卡，迅速增加活动曝光率，提升店铺流量，提升转化率。",
        },
        {
          path: "integralTask",
          id: 1,
          title: "日历签到",
          icon: require("@/assets/images/integralCenter/NewHome/Recommend_rlqd.png"),
          content: "支持每日签到、连续签到、累计签到多种赠送方式，增强会员粘性。",
        },
      ],
      TimeRenew: false, //是否显示悬浮框
      shopDetails: {}, //店铺信息
      userphoneVisible: false, //弹窗
      bannerList: [], //轮播图
      //
      popularList: [
        {
          id: "1",
          name: "开卡有礼",
          path: "integralEden/cardGiftBag",
          des: "支持针对会员和非会员设置不同的礼包弹窗，引导非会员开卡入会，开卡入会率提升276%",
          img: require("@/assets/thdImg/home/hy_kclb.svg"),
          bgimg: "",
        },
        {
          id: "3",
          name: "首单专享礼",
          path: "integralEden/firstPurchase",
          des: "通过首单专享礼权益，商家可对会员进行首单奖励，首次下单转化率提升37%",
          img: require("@/assets/images/integralCenter/sgyl.png"),
          bgimg: "",
        },
        {
          id: "4",
          name: "复购有礼",
          path: "integralEden/repurchaseCourtesy",
          des: "通过复购有礼权益，商家可对会员进行复购奖励，店铺复购率提升42%",
          img: require("@/assets/images/integralCenter/fgyl.png"),
          bgimg: "",
        },
        {
          id: "5",
          name: "下单有礼",
          path: "integralEden/orderPolitely",
          des: "可对会员进行下单奖励设置，通过下单权益刺激，下单转化率提升47.8%",
          img: require("@/assets/images/integralCenter/xdyl.png"),
          bgimg: "",
        },
        {
          id: "6",
          name: "预售有礼",
          path: "integralEden/presellPolitely",
          des: "针对预售商品设置下单，刺激用户下单预售商品，引导预售下单率7%",
          img: require("@/assets/thdImg/home/hot_ysyl.svg"),
          bgimg: "",
        },
        {
          id: "2",
          name: "刮刮乐",
          path: "cardManage/scratchers?activityType=26",
          des: "刮刮乐抽奖smartCard小部件的方式在店铺首页展示，用户在首页直接参与抽奖，,无需二跳，参与率提升65%，并且点击率为首页点击率的4+倍",
          img: require("@/assets/images/cardManage/scratch.png"),
          bgimg: "",
        },
      ],
      mapList: [
        {
          id: "1",
          logo: require("@/assets/thdImg/home/lx.svg"),
          name: "拉新",
          children: [
            {
              id: "1-1",
              name: "开卡礼包",
              icon: require("@/assets/thdImg/home/hy_mrqhl.svg"),
              path: "integralEden/cardGiftBag",
            },
            {
              id: "1-2",
              name: "店铺礼包",
              des: "(千人千面)",
              icon: require("@/assets/thdImg/home/lx_dplb.svg"),
              path: "integralEden/shopGiftBagTptn",
            },
            {
              id: "1-3",
              name: "关注店铺有礼",
              icon: require("@/assets/thdImg/home/lx_gzdp.svg"),
              path: "integralTask/followShop",
            },
            {
              id: "1-4",
              name: "完善信息有礼",
              icon: require("@/assets/thdImg/home/lx_wsyl.svg"),
              path: "integralTask/improveInformation",
            },
          ],
        },
        {
          id: "2",
          logo: require("@/assets/thdImg/home/hy.svg"),
          name: "活跃",
          children: [
            {
              id: "2-4",
              name: "智能海报",
              icon: require("@/assets/thdImg/home/hy_zn.svg"),
              path: "cardManage/smartPoster?activityType=25",
            },
            {
              id: "2-3",
              name: "签到赢好礼",
              icon: require("@/assets/thdImg/home/lc_qd.svg"),
              path: "integralTask/checkIn",
            },
            {
              id: "2-1",
              name: "天降红包雨",
              icon: require("@/assets/thdImg/home/hy_tjhby.svg"),
              path: "gameHub/redpackRain",
            },

            {
              id: "2-2",
              name: "幸运抽奖",
              icon: require("@/assets/thdImg/home/hy_dzp.svg"),
              path: "interestDraw/turntableLottery",
            },
          ],
        },
        {
          id: "3",
          logo: require("@/assets/thdImg/home/zh.svg"),
          name: "转化",
          children: [
            {
              id: "3-1",
              name: "首单专享礼",
              icon: require("@/assets/thdImg/home/zh_sgyl.svg"),
              path: "integralEden/firstPurchase",
            },
            {
              id: "3-4",
              name: "预售有礼",
              icon: require("@/assets/thdImg/home/zh_ysyl.svg"),
              path: "integralEden/presellPolitely",
            },
            {
              id: "3-2",
              name: "下单有礼",
              icon: require("@/assets/thdImg/home/zh_xdyl.svg"),
              path: "integralEden/orderPolitely",
            },
            {
              id: "3-3",
              name: "下单抽奖",
              icon: require("@/assets/thdImg/home/hy_dzp.svg"),
              path: "integralEden/orderLottery",
            },
          ],
        },
        {
          id: "4",
          logo: require("@/assets/thdImg/home/lc.svg"),
          name: "留存",
          children: [
            {
              id: "4-1",
              name: "评价有礼",
              icon: require("@/assets/thdImg/home/lc_pjyl.svg"),
              path: "integralEden/evaluatePolitely",
            },

            {
              id: "4-2",
              name: "复购有礼",
              icon: require("@/assets/thdImg/home/lc_fgyl.svg"),
              path: "integralEden/repurchaseCourtesy",
            },
            {
              id: "4-4",
              name: "积分兑换优惠券",
              icon: require("@/assets/thdImg/home/lb_lbsq.svg"),
              path: "integralMall/exchangeCoupon",
            },
            {
              id: "4-3",
              name: "下单有礼",
              icon: require("@/assets/thdImg/home/zh_xdyl.svg"),
              path: "integralEden/orderPolitely",
            },
          ],
        },
        {
          id: "5",
          logo: require("@/assets/thdImg/home/lb.svg"),
          name: "裂变",
          children: [
            {
              id: "5-2",
              name: "裂变神券",
              icon: require("@/assets/thdImg/home/lb_lbsq.svg"),
              path: "fisionMarketing/fissionDivine",
            },
            {
              id: "5-1",
              name: "邀请开卡有礼",
              icon: require("@/assets/thdImg/home/lb_yqkc.svg"),
              path: "fisionMarketing/invitationCard",
            },
            {
              id: "5-3",
              name: "邀请关注有礼",
              icon: require("@/assets/thdImg/home/lc_yqgz.svg"),
              path: "fisionMarketing/inviteFollowStore",
            },
            {
              id: "5-4",
              name: "欢乐娃娃机",
              icon: require("@/assets/thdImg/home/lb_zww.svg"),
              path: "gameHub/catchDoll",
            },
          ],
        },
      ],
      userInfo: {},
      actCount: {},
      actNotList: [],
      customParams: {}
    };
  },
  created() {
    this.getUser();
    this.TimeRenew = sessionStorage.getItem("TimeRenew") ? sessionStorage.getItem("TimeRenew") : false;
    // 轮播图广告位 高度自适应
    var fun_poster = function fun_poster() {
      let my_div = document.getElementsByClassName("poster")[0].childNodes[0].childNodes[0];
      let width = document.defaultView.getComputedStyle(my_div, null);
      my_div.style.maxHeight = Math.round(parseInt(width.width) * 0.48) + "px";
    };
    window.onresize = function() {
      fun_poster();
    };
    setTimeout(() => {
      fun_poster();
    }, 200);
    getHomeGetCarousel().then((res) => {
      this.bannerList = res.data;
    });
  },
  mounted() {
    this.openWin();
    this.visibleXitou = sessionStorage.getItem("visibleXitou") ? true : false;
    this.querySellerSetting();
    this.actInfo();

    window.JM_SHOP_MENU.on('handleNpsStatus', () => {
      console.log('NPS completed');
    });
  },
  methods: {
    // 调用白条弹窗
    getJdMicroAppOpen() {
      if(!window.jdMicroAppOpenInstance) {
        window.jdMicroAppOpenInstance = window.jdMicroAppOpen.create();
      }
      // 先调下clear,确保组件未渲染
      jdMicroAppOpenInstance.clear()
      let params = {
        appKey: this.appKey,
        target: "#whiteBar",
        componentId: this.componentId,
        getOnceToken: async() => {
          const res = await getMAToken({componentId: this.componentId})
          const res1 = await getOnceToken({maTokee: res.data.token})
          return res1.data.token
        },
        customParams: {
          sourceType: 'ISVJHK',
          reqId: this.reqId
        }
      }
      // 打开组件
      jdMicroAppOpenInstance.open(params);
    },
    getWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
          this.reqId = res.data.reqId
          this.frontComponentUrl = res.data.frontComponentUrl;
          if(this.access&&!this.isPopVisiv) {
            this.checkPopupPermission()
          }
        }
      })
    },
     // 检查弹窗权限（1天内只显示一次）
     checkPopupPermission() {
      const today = new Date().toISOString().split('T')[0]; // 获取当前日期 YYYY-MM-DD
      const lastShowDate = localStorage.getItem('popup_last_show_date');
      
      // 如果没有记录或记录日期不是今天，则显示弹窗
      if (!lastShowDate || lastShowDate !== today) {
        this.getJdMicroAppOpen()
        localStorage.setItem('popup_last_show_date', today); // 记录今天日期
      }
    },
    handleUrl() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    pupupList() {
      validPopups().then((res) => {
        if (res.data && res.data.length > 0) {
          this.popItem = res.data[0];
          this.popList = res.data;
          this.popIndex = 0;
          this.isPopVisiv = sessionStorage.getItem("isPopVisiv") ? true : false;
        }
        this.getWhiteBarPop()
      });
    },
    beforeClose() {
      displayRecord(this.popItem.id);
      if (this.popList.length == this.popIndex + 1) {
        this.isPopVisiv = false;
        sessionStorage.removeItem("isPopVisiv");
      } else {
        this.isPopVisiv = false;
        setTimeout(() => {
          this.popIndex = this.popIndex + 1;
          this.popItem = this.popList[this.popIndex];
          this.isPopVisiv = true;
        }, 500);
      }
      if(this.access) {
        this.getWhiteBarPop()
      }
    },
    handleClose() {
      sessionStorage.removeItem("visibleXitou");
      this.visibleXitou = false;
      // querySellerSetting({}).then((res) => {
      //   this.userInfo = res.data;
      //   if (res.data.mobile == "" || !res.data.mobile) {
      //     this.userphoneVisible = true;
      //   }
      // });
    },
    handleActCount(i) {
      this.$router.push({ path: "activityManage", query: { type: i } });
    },
    async actInfo() {
      let { data: res } = await activityCount();
      this.actCount = res;
      let { data } = await activitysysNotice();
      this.actNotList = data;
    },
    // navTo(item) {
    //   if (item.url) {
    //     window.open(item.url, "_blank");
    //   }
    // },
    navTo(url, item) {
      if (url.length == "0") {
        this.noticeDialogVisible = true;
        this.linkContent = item.content;
        return;
      } else {
        window.open(url, "_blank");
      }
    },
    handleCreate(item) {
      // this.$router.push({ path: item.path, query: { type: 1 } });
      this.$router.push({ path: item.path });
    },
    editNewClose() {
      this.isShowNewTip = false;
      this.querySellerSetting();
    },
    editClose() {
      this.isShowNewTip = false;
      localStorage.setItem("isShowTip" + this.venderId, "false");
      this.querySellerSetting();
    },
    async getUser() {
      let { data } = await this.get_getPoint();
      console.log("888888", data);
      // console.log('data',data)
      if (data) {
        let day;
        let resDate = await this.p_newData(data.invalidateDate);
        let newDate = await this.p_newData(new Date());
        // 自营
        sessionStorage.setItem("venderType", data.venderType);
        this.$store.commit("venderTypeChange", data.venderType);
        resDate = Date.parse(new Date(resDate));
        newDate = Date.parse(new Date(newDate));
        day = parseInt((resDate - newDate) / (1000 * 60 * 60 * 24)) - 1;
        data.day = day;
        this.shopDetails = data;
        //弹框
        this.venderId = data.venderId;
        const newRoute = window.location.href;
        const isTip = localStorage.getItem("isShowTip" + this.venderId);
        if (newRoute.indexOf("integralCenter") !== -1) {
          if (newRoute.indexOf("home") !== -1) {
            if (isTip) {
              if (isTip === "false") {
                this.isShowNewTip = false;
              } else {
                this.isShowNewTip = true;
              }
            } else {
              this.isShowNewTip = true;
            }
          } else {
            this.isShowNewTip = false;
          }
        }
      }
    },
    get_getPoint() {
      return getPoint(`/seller/current`);
    },
    // 判断是否需要填写联系人信息
    closeSystemTip() {
      this.userphoneVisible = false;
      this.pupupList();
    },
    querySellerSetting() {
      querySellerSetting({})
        .then((res) => {
          this.userInfo = res.data;
          if (res.data.mobile == "" || !res.data.mobile) {
            this.userphoneVisible = true;
          } else {
            this.customParams = {
              nps: {
                npsNodeIdLv1: 'CJ_LISTEN_JM_ISV',
                npsNodeIdLv2: 'CJ_LISTEN_JM_ISV_JHK',
                token: res.data.encryptedToken, // 传入token证明是isv商家
                npsStatus: true,
                placement: 'right',
              },
            }
            this.pupupList();
          }
        })
        .catch((e) => {});
    },

    //时间方法
    p_newData(dataTime) {
      const d = new Date(dataTime);
      return d.getFullYear() + "-" + this.p_DateTime(d.getMonth() + 1) + "-" + this.p_DateTime(d.getDate());
    },
    p_DateTime(s) {
      return s < 10 ? "0" + s : s;
    },
    ////////////////////////////////////////////////////////////////////////////////
    //判断图片是否有效
    imgError(url, item, urlName) {
      item[urlName] = "";
    },

    on_renew() {
      const href = "https://fw.jd.com/main/detail/FW_GOODS-1415006";
      window.open(href, "_blank");
    },
    on_banner() {
      const href = "https://www.wjx.top/vj/hD8iioY.aspx";
      window.open(href, "_blank");
    },
    on_QQ() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    close_TimeRenew() {
      (this.TimeRenew = false), sessionStorage.removeItem("TimeRenew");
    },

    //快捷入口 ,
    on_QuickEntrance(path, type) {
      // const res = await prefixurl();
      const query = {
        type: type,
        // url:JSON.stringify(res.data.activityUrl),
        // venderId:res.data.venderId,
      };
      this.$router.push({ path: path, query: query });
    },
    // 轮播图跳转
    handleBanner(item) {
      if (item.pathType == 1) {
        this.$router.push(item.pathUrl);
      } else if (item.pathType == 0) {
        window.open(item.pathUrl, "_blank");
      }
    },
    handleWord(num) {
      if (num === "1") {
        window.open("https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c?# 《一、京获客介绍》", "_blank");
      } else {
        window.open("https://www.yuque.com/yunduanxincrm/flgan6/omxymfdzyo6fs8ez", "_blank");
      }
    },
    setCookie(name, value, expire) {
      window.document.cookie = name + "=" + escape(value) + (expire == null ? "" : "; expires=" + expire.toGMTString());
    },
    getCookie(Name) {
      var search = Name + "=";
      if (window.document.cookie.length > 0) {
        // if there are any cookies
        let offset = window.document.cookie.indexOf(search);
        if (offset != -1) {
          // if cookie exists
          offset += search.length;
          // set index of beginning of value
          let end = window.document.cookie.indexOf(";", offset);
          // set index of end of cookie value
          if (end == -1) end = window.document.cookie.length;
          return unescape(window.document.cookie.substring(offset, end));
        }
      }
      return null;
    },
    register(name) {
      var today = new Date();
      var expires = new Date();
      console.log(expires.setTime(today.getTime()));
      expires.setTime(today.getTime() + 1000 * 60 * 60 * 24);
      // expires.setTime(today.getTime() + 1000 * 60 * 5);
      this.setCookie("ItDoor2", name, expires);
    },
    openWin() {
      var c = this.getCookie("ItDoor2");
      if (c != null) {
        sessionStorage.removeItem("visibleXitou");
      } else {
        this.register("xiaolin2");
        sessionStorage.setItem("visibleXitou", "true");
      }
    },
  },
  components: {
    notieceDialog,
    systemDialog,
  },
};
</script>

<style lang="scss" scoped>
.tip{
  margin:20px 24px 0 24px;
  background-color:#fdf6ec;
  color:#e9ae56;
  padding:10px;
  border-radius:6px;
}
.glurTop {
  margin: 20px 24px 0 24px;
  height: 50px;
  background: #6847f6;
  border-radius: 12px;
  position: relative;
  &_btn {
    width: 7%;
    height: 36px;
    /* background-color: red; */
    position: absolute;
    top: 28%;
    right: 15.9%;
    opacity: 0;
  }
}
.integral_Home_content {
  width: 100%;
  padding: 25px 20px 20px 20px;
  display: flex;
  min-width: 1080px;

  .glurLeft {
    flex: 1;
    // height: 829px;
    margin-right: 24px;
    // overflow: hidden;
  }
  .glurRight {
    // height: 829px;
    width: 424px;
    overflow: hidden;
    min-width: 242px;
  }
  .mapImg::before {
    content: "";
    width: 2px;
    height: 16px;
    background: #7b61ff;
    border-radius: 1px 1px 1px 1px;
    margin-right: 8px;
  }
  .left {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-flow: column wrap;
    justify-content: flex-start;
    // overflow: hidden;
    .hot {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 21px;
      padding: 0px 10px 15px 10px;
      display: flex;
      align-items: center;
    }
    .hotImg::before {
      content: "";
      width: 19px;
      height: 19px;
      background: url("../../../assets/thdImg/home/hot.svg") no-repeat;
      // display: inline-block;
      margin-right: 4px;
    }

    .modular_Adsense {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      padding: 0 7px;
      .modular_content {
        width: 184px;
        height: 368px;
        .content_top {
          width: 100%;
          height: 336px;
          background: rgba(255, 255, 255, 0.2);
          box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          border: 1px solid #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .content_img {
            width: 168px;
            height: 323px;
            // background: #7f85e9;
          }
          &:hover .content_bgimg {
            display: block;
          }
          .content_bgimg {
            display: none;
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0);
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #7b61ff;
            box-sizing: content-box;
            overflow: hidden;
          }
          .adsense_wz {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 120px;
            background: rgba(255, 255, 255, 0.85);
            box-shadow: 0px -4px 10px 1px rgba(0, 0, 0, 0.2);
            border-radius: 0px 0px 12px 12px;
            .adsense_cont {
              width: 100%;
              height: 88px;
              font-size: 12px;
              color: #333333;
              padding: 6px;
              line-height: 16px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; /*重点，不能用block等其他*/
              -webkit-line-clamp: 5; /*重点IE和火狐不支持*/
              -webkit-box-orient: vertical; /*重点*/
              -webkit-line-clamp: 5;
            }
            .adsense_btn {
              width: 100;
              height: 34px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #7b61ff;
              color: #ffffff;
              border-radius: 0px 0px 12px 12px;
              &::after {
                content: "";
                width: 14px;
                height: 14px;
                margin-left: 6px;
                background: url("../../../assets/thdImg/home/create.svg") no-repeat;
              }
            }
          }
        }
        .content_bottom {
          width: 100%;
          height: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #222222;
        }
      }
    }

    .modular_QuickEntrance {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .ability_map {
        width: 226px;
        height: 418px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        overflow: hidden;
        .ability_top {
          width: 100%;
          height: 46px;
          border-radius: 12px 12px 0px 0px;
          border-bottom: 1px solid #f1f3ff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
        }
        .ability_bottom {
          width: 100%;
          height: calc(322px - 46px);
          padding: 10px 0;
          display: flex;
          flex-wrap: wrap;
          margin-top: 8px;
          // align-content: space-between;
        }
        .action {
          width: 100%;
          // background: green;
          height: 92px;
          padding: 0 8px 0 16px;
          // padding: 18px 0 18px 16px;
          display: flex;
          &_img {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background: rgba(249, 114, 74, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &_js {
            width: 100%;
            flex: 1;
            padding: 4px 10px;
            &_wz {
              color: #333333;
              font-size: 16px;
              margin-bottom: 8px;
            }
            &_btn {
              width: 72px;
              height: 25px;
              font-size: 12px;
              background: rgba(38, 112, 251, 0.1);
              border-radius: 4px 4px 4px 4px;
              color: #7b61ff;
              text-align: center;
              line-height: 25px;
              &:hover {
                background: #7b61ff;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-flow: column wrap;
    justify-content: flex-start;
    overflow: hidden;
    .shop_Details {
      width: 100%;
      height: 405px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      margin-bottom: 20px;
      padding: 12px;
      .news {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &_content {
          font-size: 18px;
          color: #333333;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
        }
        &_more {
          cursor: pointer;
          color: #7b61ff;
        }
      }
      .information {
        width: 100%;
        // background: green;
        height: 80px;
        padding: 10px 0 0 24px;
        border: 1px solid #f1f3ff;
        display: flex;
        &_img {
          width: 48px;
          height: 48px;
          min-width: 48px;
          border-radius: 50%;
          // background: #f88d3b;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &_js {
          width: 100%;
          flex: 1;
          padding: 4px 10px;
          &_wz {
            color: #333333;
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 8px;
            min-width: 148px;
            width: 323px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          &_btn {
            width: 60px;
            height: 21px;
            line-height: 21px;
            text-align: center;
            background: #fff1e9;
            color: #653517;
            font-size: 12px;
            border-radius: 21px 21px 21px 21px;
          }
        }
      }
      .information_hd {
        width: 100%;
        margin-top: 10px;
        // padding: 10px 0 0 24px;
        font-size: 14px;
        height: 129px;
        overflow-y: auto;
        overflow-x: hidden;
        .information_wz {
          color: #333333;
          height: 31px;
          line-height: 31px;
          min-width: 215px;
          display: flex;
          align-items: center;
          &_but {
            color: #7b61ff;
            font-size: 12px;
            width: 48px;
            height: 21px;
            // background: rgba(123, 97, 255, 0.1);
            border-radius: 4px;
            // padding: 0 4px;
            line-height: 19px;
            text-align: center;
            margin-right: 10px;
            border: 1px solid;
          }
          &_time {
            font-size: 12px;
            margin-left: 4px;
            color: #999;
          }
          &_name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #666666;
            flex: 1;
          }
        }
      }
    }

    .customer_service {
      width: 100%;
      height: 322px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      padding: 12px;
      .contact {
        width: 100%;
        &_title {
          margin-bottom: 16px;
          font-size: 18px;
          color: #333333;
          font-weight: 600;
          display: flex;
          align-items: center;
        }
        &_wz {
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #666666;
          min-width: 218px;
        }
        &_code {
          height: 100px;
          width: 184px;
          margin-left: 64px;
          display: flex;
        }
        &_manual {
          width: 98%;
          display: flex;
          margin-top: 8px;
          justify-content: space-between;
          &_btn {
            width: 192px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: #ffffff;
            color: #7b61ff;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #7b61ff;
          }
        }
        .qq_service {
          display: flex;
          // padding-left: 5px;
        }
        .service1 {
          font-size: 12px;
          width: 69px;
          height: 25px;
          background: #7b61ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          margin-right: 8px;
          border-radius: 4px 4px 4px 4px;
          &::before {
            content: "";
            width: 12px;
            height: 12px;
            margin-right: 3px;
            background: url("../../../assets/thdImg/home/service.svg") no-repeat;
          }
        }
      }
    }

    .poster {
      width: 100%;
      min-width: 218px;
      // height: 275px;
      border-radius: 8px;
      margin-bottom: 24px;
      /deep/.el-carousel {
        .el-carousel__container {
          height: 221px;
          .el-carousel__item {
            cursor: pointer;
            img {
              width: 100%;
            }
          }
        }
        .el-carousel__indicators {
          margin-top: 10px;
          .el-carousel__button {
            background: #fff;
            border-radius: 50%;
            width: 4px;
            height: 4px;
          }
          .is-active .el-carousel__button {
            width: 18px;
            border-radius: 6px;
            opacity: 1;
          }
        }
      }
      /deep/.el-carousel__arrow {
        display: none !important;
      }
    }
  }
  .act_details {
    display: flex;
    margin: 10px 30px;
    &_pro {
      width: 50%;
      display: flex;
      /* padding-top: 10px; */
      align-items: center;
      height: 69px;
      img {
        margin-right: 6px;
        height: 40px;
      }
    }
    &_content {
      span {
        width: 22px;
        height: 24px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 23px;
      }
      div {
        width: 42px;
      }
    }
  }
}

@media screen and (max-width: 1540px) {
  .integral_Home_content {
    .left {
      .modular_content {
        width: 176px !important;
        &:last-child {
          display: none;
        }
      }
      .content_img {
        width: 161px !important;
      }
      .ability_map {
        width: 177px !important;
      }
      .action_js_wz {
        font-size: 14px !important;
      }
    }
    .glurRight {
      width: 242px;
    }
    .right {
      .shop_Details {
        height: 344px;
      }
      .customer_service {
        height: 383px;
      }
      .information_hd {
        height: 156px !important;
      }
    }
    .contact_code {
      margin-left: 0 !important;
    }
    .information_js_wz {
      width: 148px !important;
    }
    .contact_manual {
      display: block !important;
      > div {
        width: 205px !important;
      }
      .contact_manual_btn:first-child {
        margin-bottom: 10px;
      }
    }
  }
}

.shopDetails_ExpirationTime {
  width: 100px;
  height: 106px;
  position: absolute;
  top: 20px;
  right: 23px;

  > img {
    width: 100%;
    position: absolute;
    z-index: 2;
  }

  .close {
    position: absolute;
    top: -15px;
    right: -15px;
    z-index: 2;
    cursor: pointer;
  }

  .conte {
    position: relative;
    z-index: 3;
    display: flex;
    flex-flow: column wrap;

    span {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      line-height: 11px;
      color: #fe4a10;
      text-align: center;
    }

    .conte_1 {
      margin-top: 38px;
      height: 32px;
      font-size: 12px;

      mark {
        display: inline-flex;
        background: transparent;
        font-size: 36px;
        width: 40px;
        justify-content: center;
        font-family: DIN;
        color: #fe4a10;
      }
    }
  }

  .Exp-btn {
    position: absolute;
    z-index: 3;
    width: 76px;
    height: 23px;
    bottom: -10px;
    left: 13px;

    .btn {
      width: 76px;
      height: 23px;
      font-size: 12px;
      border: 1px solid #ffffff;
      background: linear-gradient(180deg, #fc8529 0%, #ff2c04 100%);
      border-radius: 13px;
      color: #fff;
      text-align: center;
      line-height: 18px;
      box-shadow: 1px 2px 1px #fd6d2f;
      animation: bbc 0.8s infinite;
      -webkit-transform: scale(1);
      cursor: pointer;
    }

    @keyframes bbc {
      0% {
        -webkit-transform: scale(1);
      }

      50% {
        -webkit-transform: scale(1.2);
      }

      100% {
        -webkit-transform: scale(1);
      }
    }
  }
}

/deep/.dialong_transition {
  .el-dialog {
    background: transparent;

    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }

  .circle {
    color: #dedddc;
    // border: 2px solid #dedddc;
    // width: 36px;
    // height: 36px;
    text-align: center;
    line-height: 28px;
    border-radius: 50%;
    display: inline-block;
    font-size: 26px;
    position: absolute;
    right: 6px;
    top: 58px;
    cursor: pointer;
  }
}
</style>
